export const CatGeneralCdpHandle = {
  CatAllFeedTypesHandle: 'fur-katzen-alle-fleischsorten',
  CatWetFoodHandle: 'fur-katzen-nassfutter',
  CatDryFoodHandle: 'fur-katzen-trockenfutter',
  CatSnacksHandle: 'fur-katzen-snacks',
} as const;
